import whatInput from 'what-input';
import googleMap from '../lib/googleMap';
import zenrinMap from '../lib/zenrinMap';

// Itinerary Map
export default $target => {
  // アイコン画像のパス
  const iconBase = '/japan-travel-planner/recommendation/img/';

  // 一覧情報を取得して整形
  const featureContent = [].slice.call(document.querySelectorAll('.v1-itineraryMap__button'));
  const iconNumber = [].slice.call(document.querySelectorAll('.v1-itineraryMap__iconNumber'));
  const mapFeature = [];
  const bounds = {
    // sw 全ポイントの南西
    sw: {
      lat: null,
      lng: null,
    },
    // ne 全ポイントの北東
    ne: {
      lat: null,
      lng: null,
    },
  };
  Array.prototype.forEach.call(featureContent, item => {
    const latlng = item.dataset.latlng.replace(/\s/g, '').split(',');
    const result = {
      listDom: item,
      name: item.innerHTML.trim(),
      latlng,
      icon: `${iconBase}${item.dataset.icon.trim()}.png`,
      map: item.dataset.map.replace(/\s/g, ''),
    };
    mapFeature.push(result);

    // 地図の中心を決めるために 全ポイントの南西、北東ポイントを取得
    bounds.sw.lat = !bounds.sw.lat || bounds.sw.lat > +latlng[0] ? +latlng[0] : bounds.sw.lat;
    bounds.ne.lat = !bounds.ne.lat || bounds.ne.lat < +latlng[0] ? +latlng[0] : bounds.ne.lat;
    bounds.sw.lng = !bounds.sw.lng || bounds.sw.lng > +latlng[1] ? +latlng[1] : bounds.sw.lng;
    bounds.ne.lng = !bounds.ne.lng || bounds.ne.lng < +latlng[1] ? +latlng[1] : bounds.ne.lng;
  });

  // 表示中ページの地域
  const mapAPI =
    location.pathname.split('/')[1] === 'zh' && location.pathname.split('/')[2] === 'cn' // eslint-disable-line
      ? 'ZDC'
      : 'Google';

  // インスタンス化
  let itineraryMap;
  if (mapAPI === 'Google') {
    // 外部MAPアプリ展開テキストの取得
    const mapAppText = document.querySelector('.v1-itineraryMap__usageGuide').innerText;

    // 別窓リンクの言語適用済み免責事項テキストを、既存の要素から取得
    const externalLink = document.querySelector('.js-external-link');
    const noteText = externalLink.getAttribute('aria-label') || '';

    itineraryMap = googleMap({
      mapFeature,
      mapOption: {
        target: $target,
        styles: [
          {
            featureType: 'all',
            elementType: 'labels.text',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
        ],
      },
      noteText,
      mapAppText,
      bounds,
    });
    itineraryMap.init();

    // 倍率調整
    window.matchMedia('(min-width:768px)').addListener(e => { // eslint-disable-line
      itineraryMap.setCenter();
    });
  } else {
    // ゼンリンいつもNavi
    itineraryMap = zenrinMap({
      mapFeature,
      mapOption: {
        target: $target,
      },
      bounds,
    });
    itineraryMap.init();

    // 地図の表示範囲がリサイズと連動できないため手動設定
    // リサイズ後、1秒以上静止したら地図をリフレッシュ
    let timer = null;
    const actRefresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        itineraryMap.setCenter();
      }, 1000);
    };
    window.addEventListener('resize', actRefresh, false);
  }

  // ピンがすべて表示範囲におさまった状態に調整
  itineraryMap.setCenter();

  // リストのクリック
  Array.prototype.forEach.call(featureContent, (item, index) => {
    const changeCurrent = e => {
      if (whatInput.ask() === 'keyboard') { // eslint-disable-line
        if (e.code === 'Space' || e.key === 'Spacebar' || e.code === 'Enter' || e.key === 'Enter') {
          e.stopPropagation();
          e.preventDefault();
          itineraryMap.changeCurrent(event.currentTarget.index, 'keyboard'); // eslint-disable-line
        }
      } else itineraryMap.changeCurrent(event.currentTarget.index); // eslint-disable-line
      const numberElm = e.target.previousElementSibling;
      iconNumber.forEach(icon => {
        icon.classList.remove('-active');
      });
      if (numberElm) {
        numberElm.classList.add('-active');
      }
    };
    item.addEventListener('click', changeCurrent, false);
    item.addEventListener('keydown', changeCurrent, false); // eslint-disable-line
    item.index = index; // eslint-disable-line
  });
};
